<template>
  <div class="device-record-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- 设备信息 Tab -->
      <el-tab-pane label="设备信息" name="info">
        <device-info-form ref="deviceInfoForm" v-if="activeTab === 'info'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
      <!-- 入库记录 Tab -->
      <el-tab-pane label="入库记录" name="retrieval">
        <retrieval-list ref="retrievalList" v-if="activeTab === 'retrieval'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
      <!-- 盘点记录 Tab -->
      <el-tab-pane label="盘点记录" name="takeStock">
        <take-stock-list ref="takeStockList" v-if="activeTab === 'takeStock'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
      <!-- 维修记录 Tab -->
      <el-tab-pane label="维修记录" name="maintenance">
        <maintenance-list ref="maintenanceList" v-if="activeTab === 'maintenance'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
      <!-- 损坏记录 Tab -->
      <el-tab-pane label="损坏记录" name="damage">
        <damage-list ref="damageList" v-if="activeTab === 'damage'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
      <!-- 报废记录 Tab -->
      <el-tab-pane label="报废记录" name="scrap">
        <scrap-list ref="scrapList" v-if="activeTab === 'scrap'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
      <!-- 关联记录 Tab -->
      <el-tab-pane label="关联记录" name="association">
        <association-list ref="associationList" v-if="activeTab === 'association'" :facility-id="facilityId" :facility-no="facilityNo" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import deviceInfoForm from './deviceInfoForm.vue';
import baseList from '@/views/components/base/baseList.vue';
import { Tag, Button } from 'view-design';
import Vue from 'vue';

// 入库记录列表组件
const RetrievalList = {
  extends: baseList,
  components: {},
  props: ['facilityId', 'facilityNo'],
  data() {
    return {
      table: {
        mname: 'devicestock',
        key: 'id',
        url: {
          del: "/admin/system/stock",
        },
        output: false,
      },
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "入库原因",
          key: "stockCause",
          minWidth: 120,
          align: "left",
        },
        {
          title: "入库地点",
          key: "stockSite",
          minWidth: 120,
          align: "left",
        },
        {
          title: "入库人",
          key: "stockBy",
          minWidth: 120,
          align: "left",
        },
        {
          title: "备注",
          minWidth: 180,
          align: "left",
          key: "remark",
        },
        {
          title: "入库时间",
          width: 115,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
      ],
    };
  },
  created() {
    if (this.facilityId) {
      this.query.facilityId = this.facilityId;
    }
  },
  methods: {},
};

// 盘点记录列表组件
const TakeStockList = {
  extends: baseList,
  components: {},
  props: ['facilityId', 'facilityNo'],
  data() {
    return {
      table: {
        mname: "facilityCheck",
        key: "id",
        url: {
          list: "/admin/system/facilityCheck/list",
        },
        output: false,
      },
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "盘点信息",
          key: "content",
          minWidth: 300,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const arr = row.content.split(",");
            return (
              <div>
                {arr.map((item) => {
                  return <div style={{ "font-size": "14px" }}>{item}；</div>;
                })}
              </div>
            );
          },
        },
        {
          title: "盘点人",
          key: "createBy",
          minWidth: 100,
          align: "left",
        },
        {
          title: "盘点时间",
          key: "createTime",
          minWidth: 120,
          align: "center",
        },
      ],
    };
  },
  created() {
    if (this.facilityId) {
      this.query.facilityId = this.facilityId;
    }
  },
  methods: {},
};

// 维修记录列表组件
const MaintenanceList = {
  extends: baseList,
  components: {},
  props: ['facilityId', 'facilityNo'],
  data() {
    return {
      table: {
        mname: 'work',
        key: 'id',
        url: {},
        output: false,
      },
      filters: [],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '资产名称',
          key: 'facilityName',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ 'font-size': '14px' }} >{text}</span>;
          },
        },
        {
          title: "问题描述",
          key: "descr",
          width: 220,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            let tempDescr;
            if (text != null) {
              let arr = text.split(']');
              let tempDate = parseInt(arr[0]);
              if (tempDate < 60) {
                tempDescr = '[' + '0h' + tempDate + 'm]' + arr[1];
              } else {
                let hour = Math.floor(tempDate / 60);
                let min = tempDate % 60;
                tempDescr = '[' + hour + 'h' + min + 'm]' + arr[1];
              }
            }
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                domProps: {
                  title: tempDescr
                }
              }, tempDescr)
            ]);
          },
        },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修时间",
          minWidth: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "具体位置",
          key: "address",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          minWidth: 100,
          align: "left",
          key: "repairBy",
          sortable: true,
          tooltip: "true",
        },
        {
          title: "报修电话",
          key: "repairPhone",
          minWidth: 130,
          align: "left",
          copy: true,
        },
        {
          title: "协同工单",
          key: "isSynergy",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.isSynergy === 0 ? "否" : "是";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 3 ? "已完成" : row.state === 2 ? "处理中" : row.state === 1 ? "待处理" : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "报修来源",
          key: "repairSource",
          minWidth: 110,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.repairSource === 1 && row.isFastOrder === 0 ? "扫码报修" :
              row.repairSource === 1 && row.isFastOrder === 1 ? "移动报修" :
                row.repairSource === 4 ? "电话报修" :
                  row.repairSource === 5 && row.isFastOrder === 0 ? "用户PC普通" :
                    row.repairSource === 5 && row.isFastOrder === 1 ? "用户PC快速" :
                      row.repairSource === 3 && row.isFastOrder === 0 ? "后台设备报修" :
                        row.repairSource === 3 && row.isFastOrder === 1 ? "后台科室报修" :
                          row.repairSource === 2 ? "维修员" : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "处理人",
          key: "maintainerName",
          minWidth: 100,
          align: "left",
        },
        {
          title: "操作",
          align: "center",
          width: 190,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff"
                  }}
                >
                  详情
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    if (this.facilityNo) {
      this.query.facilityNo = this.facilityNo;
    }
  },
  methods: {
    toInfo(val) {
      $utils.url.push({
        name: "workOrder_info",
        query: { kv: val.id },
      });
    },
  },
};

// 损坏记录列表组件
const DamageList = {
  extends: baseList,
  components: {},
  props: ['facilityId', 'facilityNo'],
  data() {
    return {
      table: {
        mname: 'devicedamage',
        key: 'id',
        url: {
          del: '/admin/system/damage'
        },
        output: false,
      },
      filters: [],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '资产名称',
          key: 'facilityName',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ 'font-size': '14px' }} >{text}</span>;
          },
        },
        {
          title: '损坏原因',
          key: 'cause',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '填写人',
          key: 'writtenBy',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '备注',
          minWidth: 180,
          align: 'left',
          key: 'remark',
        },
        {
          title: '更新时间',
          minWidth: 180,
          align: 'center',
          key: 'createTime',
        },
      ],
    };
  },
  created() {
    if (this.facilityId) {
      this.query.facilityId = this.facilityId;
    }
  },
  methods: {},
};

// 报废记录列表组件
const ScrapList = {
  extends: baseList,
  components: {},
  props: ['facilityId', 'facilityNo'],
  data() {
    return {
      table: {
        mname: "devicescrap",
        key: "id",
        url: {
          del: "/admin/system/scrap",
        },
        output: false,
      },
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "报废原因",
          key: "scrapCause",
          minWidth: 120,
          align: "left",
        },
        {
          title: "报废人",
          key: "scrapBy",
          minWidth: 120,
          align: "left",
        },
        {
          title: "备注",
          minWidth: 180,
          align: "left",
          key: "remark",
        },
        {
          title: "报废时间",
          width: 115,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
      ],
    };
  },
  created() {
    if (this.facilityId) {
      this.query.facilityId = this.facilityId;
    }
  },
  methods: {},
};

// 关联记录列表组件
const AssociationList = {
  extends: baseList,
  components: {},
  props: ['facilityId', 'facilityNo'],
  data() {
    return {
      table: {
        mname: "receive",
        key: "id",
        url: {
          list: "/admin/system/receive/facility/list",
        },
        output: false,
      },
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "耗材名称",
          key: "inventoryName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "耗材型号",
          key: "inventoryModel",
          minWidth: 120,
          align: "center",
        },
        {
          title: "领用时间",
          key: "createTime",
          minWidth: 120,
          align: "center",
        },
      ],
    };
  },
  created() {
    if (this.facilityId) {
      this.query.facilityId = this.facilityId;
    }
  },
  methods: {},
};

export default {
  name: 'deviceRecordIndex',
  components: {
    deviceInfoForm,
    retrievalList: RetrievalList,
    takeStockList: TakeStockList,
    maintenanceList: MaintenanceList,
    damageList: DamageList,
    scrapList: ScrapList,
    associationList: AssociationList,
  },
  data() {
    return {
      activeTab: 'info',
      facilityId: '',
      facilityNo: '',
    };
  },
  created() {
    let query = this.$route.query;
    this.facilityId = query.facilityId;
    this.facilityNo = query.facilityNo;
  },
  methods: {
    handleTabClick(tab) {
      // Tab 切换时的逻辑
    },
  },
};
</script>

<style lang="less" scoped>
.device-record-container {
  padding: 10px;
  
  /deep/ .el-tabs__header {
    margin-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
  }
  
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
  
  /deep/ .el-tabs__item {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    padding: 0 20px;
    color: #606266;
  }
  
  /deep/ .el-tabs__item:hover {
    color: #409eff;
  }
  
  /deep/ .el-tabs__item.is-active {
    color: #409eff;
    font-weight: 500;
  }
  
  /deep/ .el-tabs__active-bar {
    background-color: #409eff;
  }
}
</style>
